import React, { useState } from 'react';
import styled from '@emotion/styled';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB';

registerLocale('en-GB', enGB);

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
  width: 100%;
`;

const Label = styled.label`
  font-size: 0.8rem;
  margin-bottom: 5px;
  text-align: left;
`;

const StyledDatePickerWrapper = styled.div`
  width: 100%;

  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container {
    width: 100%;
  }
  input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 35px;
    font-family: inherit;
    font-size: 0.8rem;
    background-color: white;
    &:focus {
      outline: none;
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
    }
  }
  .react-datepicker-ignore-onclickoutside {
    background-color: ${props => props.missing ? '#ffdddd' : 'white'};
  }
`;

const CustomDatePicker = ({ value, label, required = false, missing = false, lockMaxDate = false, ...inputProps }) => {
  if (lockMaxDate) {
    return (
      <InputContainer>
        <Label>
          {label}
          {required && <span style={{ color: '#880808' }}> *</span>}
        </Label>
        <StyledDatePickerWrapper>
          <DatePicker
            selected={value}
            dateFormat="dd/MM/yyyy"
            locale="en-GB"
            wrapperClassName="react-datepicker-wrapper"
            className="react-datepicker-ignore-onclickoutside"
            missing={missing}
            maxDate={moment().toDate()}
            minDate={moment().subtract(2, 'years').toDate()}
            {...inputProps}
          />
        </StyledDatePickerWrapper>
      </InputContainer>
    );
  } else {
    return (
      <InputContainer>
        <Label>
          {label}
          {required && <span style={{ color: '#880808' }}> *</span>}
        </Label>
        <StyledDatePickerWrapper>
          <DatePicker
            selected={value}
            dateFormat="dd/MM/yyyy"
            locale="en-GB"
            wrapperClassName="react-datepicker-wrapper"
            className="react-datepicker-ignore-onclickoutside"
            missing={missing}
            {...inputProps}
          />
        </StyledDatePickerWrapper>
      </InputContainer>
    );
  }
};

export default CustomDatePicker;
